module.exports = __webpack_public_path__ + "static/img/TudorDavid_lettertoGeorgeBrecht_27July1960.165d454.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/brecht/archive/TudorDavid_lettertoGeorgeBrecht_27July1960.jpg
// module id = isS6
// module chunks = 0